"use client";

import { useActions, useLogicActions, useTriggers } from "@/hooks/useActionTriggerDefinitions";
import { resolveNodeVisual } from "@/lib/workflow/nodeVisual";
import { useConnectorsStore } from "@/stores/connectorsStore";
import { useMemo } from "react";

export function useResolvedNodeVisual(nodeType: string | undefined) {
  const { triggers } = useTriggers();
  const { actions } = useActions();
  const { logicActions } = useLogicActions();
  const connectorTypes = useConnectorsStore(state => state.connectorTypes);

  return useMemo(() => {
    return resolveNodeVisual(nodeType || "", [...triggers, ...actions, ...logicActions], connectorTypes);
  }, [nodeType, triggers, actions, logicActions, connectorTypes]);
}
